import _t from 'i18n!nls/page';

export const getCareerAcademyLink = (trackingParam: string) => `/career-academy?trk_ref=${trackingParam}`;
export const getCareerAcademyLabel = () => _t('Careers');

export const getAdvanceYourCareerMegaMenuItemTitle = () => _t('Advance your career');
// The casing is intentional for mega menu. This is used on mobile hamburger menu as well.
export const getFindYourNewCareerMegaMenuItemTitle = () => _t('Find your new career');
